import { OSCI0108004Q } from "@/tz/go/egaz/osci/ptl/aprv/aprv/OSCI0108004Q";
import { OSCI0108005S } from "@/tz/go/egaz/osci/ptl/aprv/aprv/OSCI0108005S";
import { OSCI0108001Q } from "@/tz/go/egaz/osci/ptl/aprv/aprvpath/OSCI0108001Q";
import { OSCI0108002S } from "@/tz/go/egaz/osci/ptl/aprv/aprvpath/OSCI0108002S";
import { OSCI0108003S } from "@/tz/go/egaz/osci/ptl/aprv/aprvpath/OSCI0108003S";
import { OSCI0109009Q } from "@/tz/go/egaz/osci/ptl/cd/cntycd/OSCI0109009Q";
import { OSCI0109010S } from "@/tz/go/egaz/osci/ptl/cd/cntycd/OSCI0109010S";
import { OSCI0109011S } from "@/tz/go/egaz/osci/ptl/cd/cntycd/OSCI0109011S";
import { OSCI0109001Q } from "@/tz/go/egaz/osci/ptl/cd/comncd/OSCI0109001Q";
import { OSCI0109002S } from "@/tz/go/egaz/osci/ptl/cd/comncd/OSCI0109002S";
import { OSCI0109003Q } from "@/tz/go/egaz/osci/ptl/cd/comncd/OSCI0109003Q";
import { OSCI0109004S } from "@/tz/go/egaz/osci/ptl/cd/comncd/OSCI0109004S";
import { OSCI0109006S } from "@/tz/go/egaz/osci/ptl/cd/comncd/OSCI0109006S";
import { OSCI0109007Q } from "@/tz/go/egaz/osci/ptl/cd/comncd/OSCI0109007Q";
import { OSCI0109008S } from "@/tz/go/egaz/osci/ptl/cd/comncd/OSCI0109008S";
import { OSCI0109012Q } from "@/tz/go/egaz/osci/ptl/cd/regncd/OSCI0109012Q";
import { OSCI0109013S } from "@/tz/go/egaz/osci/ptl/cd/regncd/OSCI0109013S";
import { OSCI0109014S } from "@/tz/go/egaz/osci/ptl/cd/regncd/OSCI0109014S";
import { Route, Routes } from "react-router-dom";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const ComnMdleRouter = () => {
    return (
        <Routes>
            {/** ==================== Code Management Router START ==================== */}
            <Route path="/comncd/osci0109001q" element={<OSCI0109001Q />} />
            <Route path="/comncd/osci0109002s" element={<OSCI0109002S />} />
            <Route path="/comncd/osci0109003q/:comnCd" element={<OSCI0109003Q />} />
            <Route path="/comncd/osci0109004s/:comnCd" element={<OSCI0109004S />} />
            <Route path="/comncd/osci0109006s/:comnCd" element={<OSCI0109006S />} />
            <Route path="/comncd/osci0109007q/:comnCd/:cdVldVal" element={<OSCI0109007Q />} />
            <Route path="/comncd/osci0109008s/:comnCd/:cdVldVal" element={<OSCI0109008S />} />

            <Route path="/cntycd/osci0109009q" element={<OSCI0109009Q />} />
            <Route path="/cntycd/osci0109010s" element={<OSCI0109010S />} />
            <Route path="/cntycd/osci0109011s/:cntyCd" element={<OSCI0109011S />} />

            <Route path="/regncd/osci0109012q" element={<OSCI0109012Q />} />
            <Route path="/regncd/osci0109013s" element={<OSCI0109013S />} />
            <Route path="/regncd/osci0109014s/:regnCd" element={<OSCI0109014S />} />
            {/** ==================== Code Management Router END ==================== */}

            {/** ==================== Approval Path Management Router START ==================== */}
            <Route path="/aprvpath/osci0108001q" element={<OSCI0108001Q />} />
            <Route path="/aprvpath/osci0108002s" element={<OSCI0108002S />} />
            <Route path="/aprvpath/osci0108003s/:aprvPrcssPathMgmtId" element={<OSCI0108003S />} />
            {/** ==================== Approval Path Management Router END ==================== */}

            {/** ==================== Approval Router START ==================== */}
            <Route path="/aprv/osci0108004q" element={<OSCI0108004Q />} />
            <Route path="/aprv/osci0108005s/:aprvId/:usrDmnId" element={<OSCI0108005S />} />
            {/** ==================== Approval Router END ==================== */}
        </Routes>
    );
};
